import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTranslate',
  standalone: true,
})
export class FormatTranslatePipe implements PipeTransform {
  transform(value: string, ...args: any[]): string {
    if (!value) return '';

    return value.replace(/{(\d+)}/g, (match, index) => {
      const argIndex = parseInt(index, 10);
      return typeof args[argIndex] !== 'undefined' ? args[argIndex] : match;
    });
  }
}
